export default __webpack_public_path__ + "static/media/supper_apps_grid_xl.d756be79.jpg";